import { DEFAULT_LAYOUT } from 'src/constants/common';

export const CONFIRM_APPOINTMENT = 'ordersPage/CONFIRM_APPOINTMENT';
export const APPOINTMENT_CONFIRMED = 'ordersPage/APPOINTMENT_CONFIRMED';
export const ACCOUNT_ORDERS_PAGE_LAYOUT = Object.freeze({
  ...DEFAULT_LAYOUT,
  main: { withNavy050BG: true, withNavy050BGMobile: true },
});
